import type { ButtonHTMLAttributes } from "react";
import { cn } from "./cn";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "danger";
  size?: "sm" | "md" | "lg";
}

const variants = {
  primary: "bg-accent text-white hover:bg-accent-strong disabled:opacity-50",
  secondary: "bg-surface text-ink border border-line hover:border-accent disabled:opacity-50",
  ghost: "bg-transparent text-ink hover:bg-hover disabled:opacity-50",
  danger: "bg-surface text-neg border border-neg-line hover:bg-neg-bg disabled:opacity-50",
};

/** Below 1024px (phone and touch-wide) every button is at least 44 × 44px (docs/design-system.md). */
const sizes = {
  sm: "h-8 px-3 text-[13.5px] rounded-lg max-lg:min-h-11 max-lg:min-w-11",
  md: "h-10 px-4 text-[14.5px] rounded-[10px] max-lg:min-h-11 max-lg:min-w-11",
  lg: "h-[54px] px-5 text-[17px] rounded-[14px] font-extrabold",
};

export function Button({
  variant = "secondary",
  size = "md",
  className,
  type = "button",
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        "inline-flex items-center justify-center gap-2 font-bold whitespace-nowrap",
        variants[variant],
        sizes[size],
        className,
      )}
      {...rest}
    />
  );
}
